<template>
  <div class="flex flex-col items-center gap-10 lg:flex-row lg:justify-between lg:items-start lg:gap-0">
    <div class="w-8/9 lg:w-13/18 mx-5">
      <!-- 左侧插槽 -->
      <div class="w-full rounded-xl h-fit shadow-rounded py-1 px-2.5">
        <slot name="left"></slot>
      </div>
      <!-- ads -->
      <div class="w-full h-fit mt-5">
        <Adsbygoogle ad-slot="5821139715" ad-format="auto" />
      </div>
    </div>
    <div class="w-8/9 lg:w-5/18 flex flex-col gap-6">
      <div class="w-full h-fit rounded-2xl shadow-rounded bg-transparent py-2.5 pl-1.5 overflow-hidden">
        <div class="mt-1 mb-3 ml-2 text-xl">GIF导出参数</div>
        <!-- 表单插槽 -->
        <div id="ops-form" class="grid gap-4 pt-4 pr-1 pb-4">
          <slot name="form"></slot>
        </div>

        <div v-if="!isRun" class="flex justify-center flex-wrap gap-2">
          <Button class="bg-[#67C23A] ml-0" @click="startConvert">开始转换</Button>
          <Button class="bg-[#F56C6C] ml-0" @click="clean">重新导入</Button>
          <Button class="bg-[#626aef] ml-0" @click="download" v-show="isConvert">下载 GIF</Button>
          <slot name="button"></slot>
        </div>
        <div v-else class="text-center">
          <Button class="bg-[#E6A23C]" @click="stop">停止</Button>
          <LoadingProgress ref="progress" class="mt-3"></LoadingProgress>
          <div class="text-center mt-4 text-gray-500 f-c flex-row gap-1">
            <SvgIcon name="loading" class="animate-spin text-xl"></SvgIcon>
            <div>{{ processText }}</div>
          </div>
        </div>
      </div>
      <slot name="preview"></slot>
      <transition name="zoom-in-top">
        <div v-show="isConvert" class="w-full overflow-hidden rounded-2xl shadow-rounded">
          <div class="flex justify-between items-center">
            <div class="text-xl my-2.5 mx-5">GIF预览</div>
            <div class="w-20 text-base text-blue-600 font-[youyuan]">{{ gifSize }}</div>
          </div>
          <img ref="targetGif" class="w-full" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Button } from '~/components/ui/button';
import confetti from 'canvas-confetti';

const emit = defineEmits(['startConvert', 'stop', 'download', 'clean']);

const props = defineProps({
  size: {
    type: Number,
    default: 0,
  },
});

const gifSize = computed(() => {
  return formatBlobSize(props.size);
});

// 输出blob的string大小
const formatBlobSize = (size: number) => {
  if (size == 0) return '';
  if (size < 1024) {
    return size + ' B';
  } else if (size < 1024 * 1024) {
    return (size / 1024).toFixed(2) + ' KB';
  } else {
    return (size / 1024 / 1024).toFixed(2) + ' MB';
  }
};

const isConvert = defineModel<boolean>('isConvert');
const isRun = defineModel<boolean>('isRun');
const processText = ref('正在处理中...');
const progress = ref();
const targetGif = ref();

const startConvert = () => {
  isConvert.value = false;
  isRun.value = true;
  nextTick(() => {
    progressInit();
    emit('startConvert');
  });
};

const stop = () => {
  isRun.value = false;
  emit('stop');
};

const download = () => {
  if (!targetGif.value.src) {
    return;
  }
  // 生成链接
  const link = document.createElement('a');
  link.href = targetGif.value.src;
  link.download = `${generateRandomTimeId()}.gif`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  toast.success('下载成功！', {
    position: 'top-center',
    closeButton: false,
  });
  emitQuestionnaire();
};

const clean = () => {
  isRun.value = false;
  isConvert.value = false;
  emit('clean');
};

const setProcessText = (text: string) => {
  processText.value = text;
};

const progressInit = (text: string = '正在处理中...') => {
  processText.value = text;
  progress.value?.init();
};

const progressInc = (incrValue: number, time: number) => {
  nextTick(() => {
    progress.value?.increase(incrValue, time);
  });
};

const setPercentage = (percent: number) => {
  nextTick(() => {
    progress.value?.setPercentage(percent);
  });
};

const progressFinish = () => {
  progress.value?.finish();
};

const showResult = (url: string) => {
  targetGif.value.src = url;
  setTimeout(() => {
    const rect = targetGif.value.getBoundingClientRect();
    const x = (rect.left + rect.width / 2) / window.innerWidth;
    const y = (rect.top + rect.height / 2) / window.innerHeight;
    confetti({
      particleCount: 100,
      spread: 70,
      ticks: 60,
      origin: { x, y },
    });
  }, 50);
};

// 问卷弹窗
const emitQuestionnaire = () => {
  window.surveylite.openSurvey({
    token: '',
    sid: '6796857487129600',
    channelId: '6796885881962496',
    width: '450px',
    externalUserId: '',
    departmentCode: '',
    externalCompanyId: '',
    env: 'https://www.xmplus.cn',
    language: '',
    animation: true,
    button: true,
    parameters: { key: 'value' },
  });
};

defineExpose({
  setProcessText,
  progressInit,
  progressInc,
  setPercentage,
  progressFinish,
  showResult,
});
</script>
